import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Stack, TextField, InputAdornment, IconButton } from '@mui/material';
import Iconify from '../../components/iconify/Iconify';
import { LoadingButton } from '@mui/lab';
import { Link as RouterLink } from 'react-router-dom';
import Swal from 'sweetalert2';
import { styled } from '@mui/material/styles';
import CustomizedProgressBars from '../../components/loader';
// components
import Api from '../../utils/Api';
import CAlert from '../../components/CAlert/CAlert';
import {
    // useDispatch, 
    useSelector
} from 'react-redux';
// import { resetData, userLogin } from '../../redux/features/userSlice';
// import SlideMessage from '../../components/SlideMessage';
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
    backgroundImage: 'url(https://cdn.prod.website-files.com/65f03c978efea1c906592c94/65f300b982243934e5c9ae8a_AdobeStock_535186049_gruen_klein.webp)',
    backgroundSize: 'cover',
    backgroundColor: '#000000',

    backgroundPosition: 'center',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
}));

const StyledContent = styled('form')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    maxHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '28px',
    // boxShadow: 'rgba(11, 211, 73, 0.42) 0px 18px 40px 4px',
    borderRadius: '10px',
    backgroundColor: 'rgb(0,0,0,0.9)'
}));

export default function Register() {
    // const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        companyname: '',
        email: '',
        password: ''
    });
    const { message } = useSelector((state) => state.user);
    // const [messageError, setMessageError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    // const [openSlide, setOpenSlide] = useState(false);  // State for slide component
    const [isLoading, setIsLoading] = useState(false)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({
            ...pre,
            [name]: value
        }));
    };

    const alertMessage = (
        <div style={{ margin: '10px 0px' }}>
            <CAlert text={message && message} type="error" />
        </div>
    );

    const handleClick = async (ev) => {
        ev.preventDefault();
        try {
            setIsLoading(true)
            const response = await Api.post('/register', formData);
            if (response.status === 201) {

                // Show sliding component
                // setOpenSlide(true);
                Swal.fire({
                    icon: "success",
                    title: "Anmeldung Erfolgreich",
                    text: response?.data?.message,
                    iconColor: '#000',
                    confirmButtonColor: '#000'
                });
                navigate("/");
            }
        } catch (error) {
            console.error('Error during registration:', error);
            Swal.fire({
                icon: 'error',
                title: 'Registrierung fehlgeschlagen',
                text: error?.response ? error?.response?.data?.message : 'Something went wrong!',
                iconColor: '#000',
                confirmButtonColor: '#000'
            });
        } finally {
            setIsLoading(false);
        }
    };

    // const handleResendEmail = async () => {
    //     try {
    //         const response = await Api.post('/resend-email', {
    //             email: formData.email,
    //         });
    //         Swal.fire({
    //             icon: 'success',
    //             title: 'Email Sent',
    //             text: response.data.message,
    //         });
    //     } catch (error) {
    //         console.error('Error during resend email:', error);
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Failed to Resend Email',
    //             text: error.response ? error.response.data.message : 'Something went wrong!',
    //         });
    //     }
    // };

    return (
        <>
            <StyledRoot>

                <Container maxWidth="sm">
                    <StyledContent onSubmit={handleClick}>

                        <img
                            src="/assets/ennovation_logo.png"
                            alt="Logo"
                            sx={{
                                display: 'block',
                                margin: '0 auto',
                                height: { xs: '80px', sm: '100px', md: '120px' }, // Adjust height based on screen size
                                width: { xs: '200px', sm: '300px', md: '380px' }, // Adjust width based on screen size
                                objectFit: 'contain',
                            }}
                        />
                        <Typography variant="h4" gutterBottom style={{ textAlign: 'center', paddingBottom: '20px', marginTop: '10px' }}>
                            {/* Register Now */}
                            Registrieren Sie sich jetzt als Aussteller
                        </Typography>
                        <Stack spacing={3} style={{ marginBottom: '30px' }}>
                            <TextField
                                required
                                name="companyname"
                                // label="Company Name"
                                label="Name der Firma"
                                onChange={handleChange} />
                            <TextField required name="email" label="E-Mail" onChange={handleChange}

                            />
                            <TextField required type={showPassword ? 'text' : 'password'}
                                name="password"
                                // label="Password"
                                label="Passwort"
                                onChange={handleChange}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Stack>
                        {message && alertMessage}
                        <LoadingButton
                            sx={{
                                boxShadow: 'none',
                                '&:focus': {
                                    boxShadow: 'none', // Remove the blue shadow
                                },
                                '&:hover': {
                                    boxShadow: 'none', // Optionally remove shadow on hover too
                                },
                            }}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            style={{ backgroundColor: '#0BD349', color: '#000000' }}>
                            {/* Register */}
                            Registrieren
                        </LoadingButton>
                        {isLoading && <CustomizedProgressBars />}
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 5,
                                textAlign: 'center',
                                pt: 5
                            }}
                        >
                            {/* Already have an account? */}
                            Sie haben bereits ein Konto?
                            <RouterLink to='/' style={{ textDecoration: 'none', color: '#fff' }}>
                                <Typography variant="subtitle2">
                                    {/* Sign In Now */}
                                    Melden Sie sich jetzt an
                                </Typography>
                            </RouterLink>
                        </Typography>

                    </StyledContent>

                </Container>

            </StyledRoot>


            {/* Slide Message Component */}
            {/* <SlideMessage
                open={openSlide}
                email={formData.email}
                onResendEmail={handleResendEmail}
            /> */}
        </>
    );
}
